<script setup>
import { useRouter, useRoute } from 'vue-router';

import Button from '@/components/ui/buttons/Button';

defineProps({
  registerButtonText: {
    type: String,
    required: false,
    default: 'createAccount',
  },

  loginButtonText: {
    type: String,
    required: false,
    default: 'login',
  },
});
const emit = defineEmits(['navigate']);
const router = useRouter();
const route = useRoute();
const navigateWithParams = (path) => {
  emit('navigate');
  router.push({
    path,
    query: { ...route.query },
  });
};
</script>

<template>
  <div class="authentication">
    <Button
      color-type="accent"
      @click="navigateWithParams('/register')"
    >
      {{ $t(registerButtonText) }}
    </Button>

    <Button
      color-type="secondary"
      @click="navigateWithParams('/login')"
    >
      {{ $t(loginButtonText) }}
    </Button>
  </div>
</template>

<style lang="scss" scoped>
.authentication {
  margin-top: 40px;

  button {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@include laptop {
  .authentication {
    padding: 16px 0;
    white-space: nowrap;
    margin-top: 0;

    button:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}
</style>
